import naja from "naja";

// We must attach Naja to window load event.
document.addEventListener('DOMContentLoaded', naja.initialize.bind(naja));
